var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loggedInUser.position &&
    _vm.loggedInUser.position.role === "manager"
    ? _c(
        "div",
        { staticClass: "colorGrey" },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", md6: "", m0a: "", "text-xs-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("h1", { staticClass: "colorPink" }, [
                    _vm._v("Sales Data Export")
                  ]),
                  _vm._v(" "),
                  _c("label", [_c("h2", [_vm._v("1. Sales Data")])]),
                  _vm._v(" "),
                  _c(
                    "v-radio-group",
                    {
                      staticClass: "radio-center",
                      attrs: { row: "" },
                      model: {
                        value: _vm.salesData,
                        callback: function($$v) {
                          _vm.salesData = $$v
                        },
                        expression: "salesData"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: { label: "Online", value: "online" }
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: { label: "Offline", value: "offline" }
                      }),
                      _vm._v(" "),
                      _c("v-radio", { attrs: { label: "Both", value: "both" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("label", [_c("h2", [_vm._v("2. Team Members")])]),
                  _vm._v(" "),
                  _c("v-select", {
                    staticStyle: { "max-width": "360px", margin: "0 auto" },
                    attrs: {
                      items: _vm.availableUsers,
                      label: "Team Members",
                      "item-value": "id",
                      "item-text": "firstName",
                      multiple: "",
                      chips: "",
                      clearable: "",
                      "menu-props": "bottom"
                    },
                    model: {
                      value: _vm.teamMembers,
                      callback: function($$v) {
                        _vm.teamMembers = $$v
                      },
                      expression: "teamMembers"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("label", [_c("h2", [_vm._v("3. Date Range")])]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs6: "", left: "" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": false,
                            "nudge-right": 40,
                            transition: "scale-transition",
                            "offset-y": "",
                            "max-width": "320px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              label: "Date from",
                                              "prepend-icon": "mdi-calendar",
                                              readonly: ""
                                            },
                                            model: {
                                              value: _vm.dateFrom,
                                              callback: function($$v) {
                                                _vm.dateFrom = $$v
                                              },
                                              expression: "dateFrom"
                                            }
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2456542422
                          ),
                          model: {
                            value: _vm.menu1,
                            callback: function($$v) {
                              _vm.menu1 = $$v
                            },
                            expression: "menu1"
                          }
                        },
                        [
                          _vm._v(" "),
                          _c("v-date-picker", {
                            attrs: {
                              max: new Date().toISOString().substr(0, 10)
                            },
                            on: {
                              input: function($event) {
                                _vm.menu1 = false
                              }
                            },
                            model: {
                              value: _vm.dateFrom,
                              callback: function($$v) {
                                _vm.dateFrom = $$v
                              },
                              expression: "dateFrom"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs6: "", left: "" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": false,
                            "nudge-right": 40,
                            transition: "scale-transition",
                            "offset-y": "",
                            "max-width": "320px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              label: "Date to",
                                              "prepend-icon": "mdi-calendar",
                                              readonly: ""
                                            },
                                            model: {
                                              value: _vm.dateTo,
                                              callback: function($$v) {
                                                _vm.dateTo = $$v
                                              },
                                              expression: "dateTo"
                                            }
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            929990390
                          ),
                          model: {
                            value: _vm.menu2,
                            callback: function($$v) {
                              _vm.menu2 = $$v
                            },
                            expression: "menu2"
                          }
                        },
                        [
                          _vm._v(" "),
                          _c("v-date-picker", {
                            attrs: {
                              min: _vm.dateFrom,
                              max: new Date().toISOString().substr(0, 10)
                            },
                            on: {
                              input: function($event) {
                                _vm.menu1 = false
                              }
                            },
                            model: {
                              value: _vm.dateTo,
                              callback: function($$v) {
                                _vm.dateTo = $$v
                              },
                              expression: "dateTo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.exportSalesData()
                        }
                      }
                    },
                    [_vm._v(" Show Sales Data ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showData
                ? _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("h1", [_vm._v(" Sales Export")]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "my-4",
                      staticStyle: { "font-size": "26px" },
                      domProps: { innerHTML: _vm._s(_vm.getDateRange()) }
                    }),
                    _vm._v(" "),
                    _vm.salesData === "both" || _vm.salesData === "online"
                      ? _c("div", { staticClass: "colorGrey mb-5" }, [
                          _c("h1", [_vm._v(" Total Online Sale")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "circleSales borderGrey" }, [
                            _vm._v("$" + _vm._s(_vm.totalOnlineSale))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.salesData === "both" || _vm.salesData === "offline"
                      ? _c(
                          "div",
                          { staticClass: "colorPink mb-5" },
                          [
                            _c("h1", [_vm._v(" Total Offline Sale")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "circleSales borderPink" },
                              [_vm._v("$" + _vm._s(_vm.totalOfflineSale))]
                            ),
                            _vm._v(" "),
                            _c("v-flex", [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(this.individualSales)
                                }
                              })
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-snackbar",
            {
              attrs: { dark: "", top: "", timeout: 3000 },
              model: {
                value: _vm.snackbar,
                callback: function($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar"
              }
            },
            [
              _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.snackbar = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1986c440", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1986c440","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SalesExport.vue
// module id = null
// module chunks = 